<template>
  <v-container class="pt-0 mt-0">
    <v-row>
      <v-spacer />
      <v-col cols="10">
        <v-form onsubmit="return false">
          <v-card>
            <v-card-title> Login </v-card-title>
            <v-card-text class="mb-0 pb-0">
              <v-text-field v-model="email" v-on:keyup.enter="$refs.password.focus()" label="Email" outlined>
              </v-text-field>
              <v-text-field v-model="password" autocomplete="current-password" v-on:keyup.enter="login()" label="Password" outlined :type="passwordType"
                :append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="toggleShowPassword()">
              </v-text-field>
            </v-card-text>
            <v-card-subtitle v-if="loginError || statusMessage">
              <v-alert dismissible close-text="Close Alert" border="left" v-model="loginError" elevation="9" type="error">{{
                  loginError
              }}</v-alert>
              <v-alert dismissible close-text="Close Alert" border="left" v-model="statusMessage" elevation="9" type="success">{{
                  statusMessage
              }}</v-alert>
            </v-card-subtitle>
            <v-card-subtitle class="ma-0 pt-0">
              <v-row class="pl-2 pr-2 pt-0 mt-0">
                <v-btn color="primary" class="mb-2" to="/sendpasswordresetlink">{{ resetPasswordLabel }}</v-btn>
                <v-spacer />
                <v-btn color="primary" class="mb-2" to="/register">Register</v-btn>
                <v-spacer />
                <v-btn color="success" @click="login()">Login</v-btn>
              </v-row>
            </v-card-subtitle>
          </v-card>
        </v-form>
      </v-col>
      <v-spacer />
    </v-row>
  </v-container>
</template>

<script>
import userFunctions from "@/functions/userFunctions";

export default {
  name: "PalmInfo",
  methods: {
    async login() {
      if (!this.email || !this.password) {
        this.loginError = "You must enter an email address and password";
        return;
      }
      userFunctions.logout();

      let result = await userFunctions.login(this.email, this.password);

      if (userFunctions.userIsLoggedIn()) {
        this.$router.push("/");
      } else {
        this.loginError = result;
      }
    },
    toggleShowPassword() {
      this.showpassword = !this.showpassword;
    },
  },
  computed: {
    resetPasswordLabel() {
      return this.$vuetify.breakpoint.xsOnly ? "Reset" : "Reset Password";
    },
    statusMessage: function () {
      if (this.$route.params.status == "registrationconfirmed") {
        return "Registration Confirmed. Please log in using the password you supplied when signing up, or use the Reset Password button to change it to another one"
      }
      return null;
    },
    showError: function () {
      return this.loginError && this.loginError.length > 0;
    },
    passwordType: function () {
      return this.showpassword ? "text" : "password";
    },
  },
  data: () => ({
    email: null,
    password: null,
    showpassword: false,
    loginError: null,
  }),
};
</script>

<style scoped>
.palm-site-green {
  background-color: rgb(176, 217, 173);
}
</style>
